import { createBrowserRouter, Navigate, redirect } from "react-router";
import authRoute from "./auth.route";
import mainRoute from "./main.route";
import { checkAuth, guardCheck } from "@/common/utils";
import { Loader } from "@/components";
import { Suspense, lazy } from "react";
import QuoteReqProvider from "@/common/contexts/QuoteReq.context";
import PermissionsProvider from "@/common/contexts/Permissions.context";
import ModalProvider from "@/common/contexts/Modal.context";
import { APIProvider } from "@vis.gl/react-google-maps";
import { libs } from "@/common/const";

const SingleSiteQuote = lazy(() => import("@/pages/SingleSiteQuote.page"));
const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));
const route = createBrowserRouter([
  {
    path: "/",
    children: [
      ...authRoute,
      ...mainRoute,
      {
        path: "/singleSiteQuote",
        loader: checkAuth,
        children: [
          {
            path: "",
            element: <Navigate to={"DIA"} replace />,
          },
          {
            path: ":productType",
            loader: async ({ params, request }) => {
              checkAuth();
              const isAllowed = guardCheck(
                request,
                "singleSiteQuote/airx/customer"
              );

              if (!isAllowed) {
                throw redirect("/404");
              }

              return params.productType;
            },
            element: (
              <APIProvider
                apiKey={GOOGLE_API_KEY}
                libraries={[...libs]}
                language="en"
              >
                <PermissionsProvider>
                  <ModalProvider>
                    <QuoteReqProvider>
                      <Suspense fallback={<Loader />}>
                        <SingleSiteQuote />
                      </Suspense>
                    </QuoteReqProvider>
                  </ModalProvider>
                </PermissionsProvider>
              </APIProvider>
            ),
          },
        ],
      },
      {
        path: "/404",
        element: <NotFoundPage />,
      },
      {
        path: "*",
        element: <Navigate to="/404" />,
      },
    ],
  },
]);
export default route;
